import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.Order,
});

export const OrderTabs = {
  Address: "address",
};

export const OrderTranslationNamespaceEnum = {
  CreateOrder: "OrderCreate",
  ProductDataGrid: "OrderProductDataGrid",
};

export const OrderQueryKeys = {
  orderBasketData: "order.basket-data",
  orderCustomerSearch: "order.customer.search",
};

export const customerModalFormKey = "order-customer-modal-form";
export const orderDeliveryAddressFormKey = "order-delivery-address-modal-form";

export const OrderStatusEnum = {
  New: "New",
  Cancelled: "Cancelled",
  Finished: "Finished",
  Problems: "Problems",
};
